import { useQuery } from '@tanstack/react-query';

import { AxiosRequestConfig } from 'axios';

import { getUnavailabilitesForProduct } from 'api/leihbar';

export const useUnavailabilitiesQuery = (productId: number, config?: AxiosRequestConfig) => {
  const query = useQuery({
    queryKey: ['unavailabilities', productId, config ? JSON.stringify(config.params) : ''],
    queryFn: () => {
      return getUnavailabilitesForProduct(productId, config);
    },
    initialData: { unavailabilities: [], articleCount: 0 } // TODO remove this
  });

  return query;
};
